var _path, _circle, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg012Customer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#f5e6fe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    fill: "#be63f9",
    r: 1.333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.833 16h-1.667c-1.011 0-1.833.822-1.833 1.833v.333c0 .276.224.5.5.5h4.333c.276 0 .5-.224.5-.5v-.333c.001-1.011-.822-1.833-1.833-1.833z",
    fill: "#be63f9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9a4fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 22.833c-3.768 0-6.833-3.065-6.833-6.833s3.065-6.833 6.833-6.833 6.833 3.065 6.833 6.833-3.065 6.833-6.833 6.833zm0-12.333c-3.033 0-5.5 2.467-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.467 5.5-5.5-2.467-5.5-5.5-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 11.667c-.368 0-.667-.299-.667-.667v-2.333c0-.369.299-.667.667-.667s.667.299.667.667v2.333c0 .368-.299.667-.667.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.333 16.667h-2.333c-.368 0-.667-.299-.667-.667s.299-.667.667-.667h2.333c.369 0 .667.299.667.667s-.298.667-.667.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 24c-.368 0-.667-.299-.667-.667v-2.333c0-.368.299-.667.667-.667s.667.299.667.667v2.333c0 .369-.299.667-.667.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 16.667h-2.333c-.369 0-.667-.299-.667-.667s.299-.667.667-.667h2.333c.368 0 .667.299.667.667s-.299.667-.667.667z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg012Customer);
export default __webpack_public_path__ + "static/media/012-customer.929c2e858498f0c76a1a5ac745f8d4d3.svg";
export { ForwardRef as ReactComponent };